// Hosted DEV environment — points the admin at the DEV API.
// Selected at build time via `ng build --environment=devhost`
// (mapped in .angular-cli.json). Keep production:false so dev diagnostics stay on.
export const environment = {
    production: false,
    apiUrl: 'https://dev-api.mysuggestion.to/'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts